export default {
      id: "icon-person-usage",
      viewBox: "0 0 48 47",
      url: __webpack_public_path__ + "img/icons.svg#icon-person",
      toString: function () {
        return this.url;
      }
    }